module.exports = __webpack_public_path__ + "static/media/Submission Tracking.6a3f1f9a.png";